<template>
  <div
    class="glass-preview"
    :data-layout="layout.slug"
    :data-color="color"
    :data-horizontal="horizontal"
    :data-shape="shape"
  >
    <small v-html="$t('product_description')"></small>
    <div class="glass">
      <div class="glass-inner">
        <slot></slot>
        <Stand />
      </div>
    </div>
  </div>
</template>
<script>
import usePhoto from "./../../usePhoto";
import { mapGetters } from "vuex";
import { optional } from "./../../../../../helpers";
import Stand from "../Stand.vue";

export default {
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
    color() {
      return this.optional(this.product.attribute_values.color).slug;
    },
    horizontal() {
      return this.product.attributes.isHorizontal;
    },
    shape() {
      return this.optional(this.product.attribute_values.loverShape).slug;
    },
  },
  setup() {
    const { layout, layoutPhotoCount, getImageUrl } = usePhoto();
    return {
      layout,
      layoutPhotoCount,
      getImageUrl,
      optional,
    };
  },
  components: { Stand },
};
</script>
